import Image from 'next/image'
import { noop } from 'lodash-es'
import { isHicampus } from '@bridge/core/constants/is-app'
import { useRouter } from 'next/router'

type LogoType = 'white' | 'black' | 'primary' | 'hicampus'

type LogoButtonProps = {
	logoType?: LogoType
	beforeOnPress?: () => void
}

const LogoButton = ({ logoType = 'white', beforeOnPress = noop }: LogoButtonProps) => {
	const router = useRouter()

	const routeMain = async () => {
		await router.push('/')
	}

	function logoOnClick () {
		beforeOnPress()
		routeMain().catch(console.error)
	}

	if (isHicampus) {
		return (
			<Image
				src='/main/logo_hicampus.svg'
				alt='briiidge project'
				width={168}
				height={32}
				style={{ cursor: 'pointer', padding: '0 14px', width: 168, height: 32 }}
				onClick={logoOnClick}
			/>
		)
	}

	return (
		<Image
			src='/main/logo_soluny.svg'
			alt='briiidge project'
			width={158}
			height={32}
			style={{ cursor: 'pointer', padding: '0 14px', width: 158, height: 32 }}
			onClick={logoOnClick}
		/>
	)
}

export default LogoButton
